import {UI} from "../../../../../stem-core/src/ui/UI";

import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {Messages} from "../../../../Messages";
import {BlinkButton} from "../../../../ui/Button.jsx";
import {LinkButton} from "../../../../../core/ui/LinkButton.jsx";
import {DEFAULT_DATE_FORMAT} from "../../../../Constants";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {SubscriptionIndexStyle} from "./SubscriptionIndex";
import {MessageElement} from "../../../ui/MessageElement";
import {startDonationFlow} from "../../../../panel/flows/FlowEntrypoint.js";


class MerchantDonationStyle extends SubscriptionIndexStyle {
    @styleRule
    recurringDonor = {
        color: this.themeProps.MERCHANT_5,
        fontWeight: "bold",
        fontSize: 14,
        textAlign: "center",
    };

    @styleRule
    amountAndFrequency = {
        color: this.themeProps.MERCHANT_2,
        paddingLeft: 8,
        fontSize: 14,
    };

    @styleRule
    descriptionContainer = {
        fontSize: 14,
        color: this.themeProps.MERCHANT_3,
        marginTop: 12,
    };

    @styleRule
    supportMerchantMessage = {
        fontSize: 16,
        textAlign: "center",
        marginTop: 18,
    };

    @styleRule
    manageDonationContainer = {
        color: this.themeProps.LINK_COLOR,
        paddingLeft: 8,
        display: "inline-block",
        fontWeight: "inherit",
        textDecoration: "none",
    };

    @styleRule
    billingDateParagraph = {
        marginTop: 12,
    };
}

@autoredraw(iFrameUserDataService)
@registerStyle(MerchantDonationStyle)
export class DonationOverview extends UI.Element {
    renderPrimaryButton() {
        const {styleSheet} = this;

        if (iFrameUserDataService.getActiveRecurringDonation()) {
            const canMakeOneTimeDonation = iFrameMerchantService.getDonationOffer().getFrequencyOptions().find(frequency => frequency.isOneTime());

            return canMakeOneTimeDonation && <BlinkButton
                onClick={() => startDonationFlow(false, true)}
                className={styleSheet.button}
                label={Messages.makeAnotherDonation}
            />
        }


        return <BlinkButton
            onClick={() => startDonationFlow()}
            className={styleSheet.button}
            label={Messages.donate}
        />;
    }

    renderSecondaryButton() {
        return iFrameUserDataService.getActiveRecurringDonation() &&
            <LinkButton
                label={Messages.editRecurringDonation}
                centered
                onClick={() => startDonationFlow(true)}
            />;
    }

    renderActiveDonation() {
        const {styleSheet} = this;
        const donation = iFrameUserDataService.getActiveRecurringDonation();

        const nextBillingDate = donation.getNextBillingDate();

        return [
            <div className={styleSheet.recurringDonor}>
                {Messages.recurringDonor(donation.formatPrice())}
            </div>,

            <div className={styleSheet.descriptionContainer}>
                {
                    nextBillingDate && <div className={styleSheet.billingDateParagraph}>
                        {Messages.activeDonationDescription1(nextBillingDate.format(DEFAULT_DATE_FORMAT))}
                    </div>
                }
                <MessageElement
                    className={styleSheet.billingDateParagraph}
                    message={Messages.activeDonationDescription2(iFrameMerchantService.getMerchant().name)}
                />
            </div>,
        ];
    }

    renderNoDonation() {
        return <div className={this.styleSheet.supportMerchantMessage}>
            {Messages.supportByDonating(iFrameMerchantService.getMerchant())}
        </div>;
    }

    render() {
        return [
            iFrameUserDataService.getActiveRecurringDonation() ? this.renderActiveDonation() : this.renderNoDonation(),
            this.renderPrimaryButton(),
            this.renderSecondaryButton(),
        ];
    }
}
